import { type TFunction } from "i18next";

import type { PaymentKind } from "../types";

/**
 * Label for the date a payment was actioned. Claims (mileage/receipt) are
 * "approved", participant-actioned payments (stipend/micropayment) are
 * "accepted"; both share the rejected label.
 */
export const getDecisionLabel = (
  kind: PaymentKind,
  status: string,
  t: TFunction
): string => {
  if (status.toLowerCase() === "rejected") {
    return t("claimDetail_dateRejected");
  }
  const isParticipantActioned = kind === "stipend" || kind === "micropayment";
  return isParticipantActioned
    ? t("claimDetail_dateAccepted")
    : t("claimDetail_dateApproved");
};
